import { createContext } from "react";

export const UserListContext = createContext({});

export const UserListAdvertisementContext = createContext({});
